import type { LucideIcon } from "lucide-react";

export type FilterOperator =
  | "is"
  | "is_not"
  | "is_either_of"
  | "includes_any"
  | "includes_all"
  | "includes_none";

export type FilterLogic = "and" | "or";

export interface FilterValue {
  id: string;
  label: string;
  icon?: LucideIcon;
  color?: string;
}

export interface FilterCategory {
  id: string;
  label: string;
  icon: LucideIcon;
  allowedOperators: FilterOperator[];
  values: FilterValue[];
}

export interface FilterCategoryGroup {
  label: string;
  categories: FilterCategory[];
}

export interface ActiveFilter {
  id: string;
  categoryId: string;
  operator: FilterOperator;
  valueIds: string[];
}

export type FilterStep =
  | { type: "closed" }
  | { type: "category_picker" }
  | { type: "value_picker"; categoryId: string }
  | { type: "editing_pill"; filterId: string };

export interface FilterContextType {
  filters: ActiveFilter[];
  logic: FilterLogic;
  step: FilterStep;
  searchQuery: string;
  isOpen: boolean;
  categoryGroups: FilterCategoryGroup[];
  addFilter: (filter: ActiveFilter) => void;
  updateFilter: (
    id: string,
    updates: Partial<Pick<ActiveFilter, "operator" | "valueIds">>,
  ) => void;
  removeFilter: (id: string) => void;
  clearAllFilters: () => void;
  toggleLogic: () => void;
  setStep: (step: FilterStep) => void;
  setSearchQuery: (query: string) => void;
  openPopover: () => void;
  closePopover: () => void;
}

export const OPERATOR_LABELS: Record<FilterOperator, string> = {
  is: "is",
  is_not: "is not",
  is_either_of: "is either of",
  includes_any: "includes any",
  includes_all: "includes all",
  includes_none: "includes none",
};
